import { API_URL, API_URL_SHOP } from "./config";
export function getBackendDataPromise(username, endpoint, method, acceptFormat, token) {
    return new Promise((resolve, reject) => {
        let request = new XMLHttpRequest();
        request.open(method, API_URL + endpoint + username);
        request.setRequestHeader('Accept', acceptFormat);
        request.setRequestHeader('Authorization', 'Bearer ' + token);
        request.addEventListener('load', function () {
            if (request.status >= 200 && request.status < 300) {
                resolve(request.responseText);
            }
            else {
                reject({
                    status: request.status,
                    statusText: request.statusText
                });
            }
        });
        request.addEventListener('error', () => {
            reject({
                status: request.status,
                statusText: request.statusText
            });
        });
        request.send();
    });
}
export function getBackendData(username, endpoint, method, acceptFormat, token, callback) {
    let request = new XMLHttpRequest();
    request.open(method, API_URL + endpoint + username);
    request.setRequestHeader('Accept', acceptFormat);
    request.setRequestHeader('Authorization', 'Bearer ' + token);
    request.addEventListener('load', callback);
    request.send();
}
export function getBackendFile(username, endpoint, method, acceptFormat, token, callback) {
    let request = new XMLHttpRequest();
    request.open(method, API_URL + endpoint + username);
    request.setRequestHeader('Accept', acceptFormat);
    request.setRequestHeader('Authorization', 'Bearer ' + token);
    request.responseType = 'blob';
    request.addEventListener('load', callback);
    request.send();
}
export function getShopBackendData(username, endpoint, method, acceptFormat, token, callback) {
    let request = new XMLHttpRequest();
    request.open(method, API_URL_SHOP + endpoint + username);
    request.setRequestHeader('Accept', acceptFormat);
    request.setRequestHeader('Authorization', 'Bearer ' + token);
    request.addEventListener('load', callback);
    request.send();
}
export function sendShopBackendData(username, endpoint, method, acceptFormat, token, body, callback) {
    let request = new XMLHttpRequest();
    request.open(method, API_URL_SHOP + endpoint + username);
    request.setRequestHeader('Accept', acceptFormat);
    request.setRequestHeader('Authorization', 'Bearer ' + token);
    request.setRequestHeader('Content-type', 'application/json');
    request.addEventListener('load', callback);
    request.send(JSON.stringify(body));
}
export function sendBackendData(username, endpoint, method, acceptFormat, token, body, callback) {
    let request = new XMLHttpRequest();
    request.open(method, API_URL + endpoint + username);
    request.setRequestHeader('Accept', acceptFormat);
    request.setRequestHeader('Authorization', 'Bearer ' + token);
    request.setRequestHeader('Content-type', 'application/json');
    request.addEventListener('load', callback);
    request.send(JSON.stringify(body));
}
